import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, DatePicker } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { MdOutlineNoteAdd } from 'react-icons/md'
import ModalTalentRow from './ModalTalentRow'
import { postNotes, updateNotes } from '../../../redux/actions'
import './NoteModals.css'

const S3_URL = process.env.REACT_APP_S3_URL || ''

const AddNoteModal = ({ open, onClose, note = null, skillListingId }) => {
  const dispatch = useDispatch()
  const skillListings = useSelector((state) => state.oneUserskillListingReducer.skillListings)
  const skillListing = skillListings?.skill_listings || {}
  const accounts = skillListing?.Profiles?.Accounts || {}
  const firstName = accounts.FirstName || ''
  const lastName = accounts.LastName || ''
  const talentName = `${firstName} ${lastName}`.trim() || 'Unknown'
  const talentTitle = skillListing.Title || ''
  const pictureUrl = accounts.PictureUrl
  const avatarSrc = pictureUrl ? `${S3_URL}/${pictureUrl}` : null
  const isEdit = !!note
  const [text, setText] = useState('')
  const [date, setDate] = useState(null)

  useEffect(() => {
    setText(note?.text ?? '')
    setDate(null)
  }, [note, open])

  const handleClose = () => {
    setText('')
    setDate(null)
    onClose()
  }

  const handleSubmit = () => {
    if (!text.trim()) return
    if (isEdit) {
      dispatch(updateNotes({
        noteId: note._id,
        Note: text,
        StartTime: date ? date.toISOString() : note.StartTime,
        EndTime: date ? date.toISOString() : note.EndTime,
        SkillListingId: skillListingId,
      }))
    } else {
      dispatch(postNotes({
        Note: text,
        SkillListingId: skillListingId,
        StartTime: date ? date.toISOString() : new Date().toISOString(),
        EndTime: date ? date.toISOString() : new Date().toISOString(),
        Status: 'pending',
      }))
    }
    handleClose()
  }

  return (
    <Modal
      open={open}
      onCancel={handleClose}
      footer={null}
      closable={false}
      className="nm-modal"
      width="min(460px, 95vw)"
      centered
      destroyOnClose
    >
      <div className="nm-header">
        <span className="nm-title">{isEdit ? 'Edit Note' : 'Add Note'}</span>
        <button className="nm-close-btn" type="button" onClick={handleClose}>
          <CloseOutlined />
        </button>
      </div>
      <div className="nm-divider" />

      <ModalTalentRow
        name={talentName}
        title={talentTitle}
        avatar={avatarSrc}
        tag="Internal"
      />

      <div className="nm-section">
        <span className="nm-label">Set Reminder</span>
        <DatePicker
          className="nm-datepicker"
          value={date}
          onChange={setDate}
          format="D MMMM YYYY"
          placeholder="Select date"
        />
      </div>

      <div className="nm-section">
        <span className="nm-label">
          Write Note Here <span className="nm-required">*</span>
        </span>
        <textarea
          className="nm-textarea"
          placeholder="Create note for the other team members."
          value={text}
          maxLength={250}
          rows={4}
          onChange={(e) => setText(e.target.value)}
        />
        <div className="nm-char-count">{text.length}/250</div>
      </div>

      <button className="nm-submit-btn" type="button" onClick={handleSubmit}>
        {isEdit ? <><MdOutlineNoteAdd /> Update Note</> : <>+ Add Note</>}
      </button>
    </Modal>
  )
}

export default AddNoteModal
